// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 11) return "static/js/ab4508b9c4bf6ce9adea.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"bf6fb31750a795a54682","139":"cda691d343b9edcc393e","140":"2dd15ace4f7b0fb592b2"}[chunkId] + ".chunk.js";
};